import {
    IDatasetTypeMetadata,
    IDynamicDatasetTypeMetadata
} from 'app/extensibility/metadatas/resource-type/dataset-type-metadata';
import { adfModelTypeMap } from '../consts/adf-model-type-map-const';
import { valueType, valueTypeOptions } from '../consts/servicenow-v2-const';
import { serviceNowObjectMetadata } from './servicenow-object-metadata';
import { supportedOperators, getConnectorV2Name, GlobalVariables } from 'shell-models-lib';
import { format } from 'app/shared/utils/string.util';
import { getServiceInstance } from 'app/multi-contexts/modules/root/root.application';
import { ExposureControlService } from 'app/services/exposure-control/base-exposure-control.service';
import { partitionOptionConst } from '../consts/metadata-consts';

export const serviceNowV2ObjectMetadata: IDynamicDatasetTypeMetadata = async (injector) => {
    const exposureControlService = await getServiceInstance<ExposureControlService>(
        injector,
        'ExposureControlService'
    );
    const metadata: IDatasetTypeMetadata = {
        ...serviceNowObjectMetadata,
        warningMessage: null,
        type: adfModelTypeMap.serviceNowV2.datasetType,
        notSupportPhysicalType: false,
        displayName: getConnectorV2Name(stringResources.ServiceNow_DisplayText, __IS_FABRIC_DPE__),
        datasetNamePrefix: adfModelTypeMap.serviceNow.datasetType,
        supportLinkedServiceTypes: [adfModelTypeMap.serviceNowV2.linkedServiceType],
        notSupportCopySourceQuery: true,
        isTableRequired: true,
        disabled: false, // overwrite serviceNowObjectMetadata
        copySourceControls: [
            {
                type: 'simple-and-or-expression',
                bind: 'expression',
                operators: supportedOperators,
                label: stringResources.QueryBuilderLabel,
                allowSelection: false,
                allowGrouping: true,
                parameterizable: true
            },
            {
                type: 'parameterizable',
                hide:  __IS_FABRIC_DPE__ || !exposureControlService.showSelectInServiceNowV2,
                child: {
                    type: 'columns-selection',
                    bind: 'selectColumns',
                    label: stringResources.ServiceNowSelectLabel,
                    description: stringResources.ServiceNowSelectDesc,
                    multiple: true,
                },
                dynamicContentTextClass: 'input-spaced'
            },
            {
                type: 'parameterizable',
                hide: __IS_FABRIC_DPE__,
                child: {
                    type: 'textbox-number',
                    bind: 'pageSize',
                    label: stringResources.PageSizeLabel,
                    inputType: 'number',
                    min: 1,
                    dataType: 'integer',
                    validators: [
                        {
                            type: 'number',
                            min: 1,
                            errorMessage: format(stringResources.Above0ErrorMessage, stringResources.PageSizeLabel)
                        }
                    ]
                },
                dynamicContentTextClass: 'input-spaced'
            },
            {
                type: 'parameterizable',
                hide: !GlobalVariables.enableServiceNowV2Partition,
                child: {
                    type: 'radio',
                    bind: 'partitionOption',
                    defaultValue: partitionOptionConst.none,
                    label: stringResources.ModelName_Partition_Option,
                    description: stringResources.autoPartitionDesc,
                    options: [
                        {
                            label: stringResources.None,
                            value: partitionOptionConst.none
                        },
                        {
                            label: stringResources.autoDetect,
                            value: partitionOptionConst.autoDetect
                        }
                    ],
                    labelPosition: 'left'
                },
                dynamicContentTextClass: 'input-spaced'
            },
        ],
        controls: [
            {
                type: 'parameterizable',
                hide: __IS_FABRIC_DPE__,
                child: {
                    type: 'radio',
                    bind: 'valueType',
                    label: stringResources.ValueType,
                    options: valueTypeOptions,
                    defaultValue: valueType.actual
                },
                dynamicContentTextClass: 'input-spaced'
            },
            {
                type: 'table-selection',
                bind: 'tableName',
                required: true,
                label: stringResources.ModelName_Table,
                refreshTableAfterInitialization: true,
                showPreviewButton: true,
                enableEditOnEmpty: false,
                parameterizable: true
            }
        ]
    };
    return metadata;
};
